import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import GA4 from 'helpers/ga4'

import { useStoreContext } from 'hooks/StoreContext'
import useArchivedDevices from 'hooks/useArchivedDevices'
import useUnassignedDevices from 'hooks/useUnassignedDevices'

type Props = {
  className?: string
}

const DeviceLinks = ({ className }: Props) => {
  const { archivedDevices, isArchivedDevicesLoaded } = useStoreContext()
  const { unassignedDevices, areUnassignedDevicesLoaded } = useStoreContext()

  useArchivedDevices()
  useUnassignedDevices()

  const navigate = useNavigate()

  const onClickAddCustomer = () => {
    GA4.sendEvent({
      category: 'Customer List Page',
      action: 'Click Add Customer'
    })

    navigate('/customers/new')
  }

  return (
    <S.Container className={className}>
      <Button
        onPress={() => { navigate('/archived_devices') }}
        enabled={isArchivedDevicesLoaded}
        decoration="textOnly"
        styles={{ button: { marginRight: 5 } }}
        text={`${archivedDevices?.length ?? 0} Archived Devices`}
      />
      <Button
        onPress={() => { navigate('/unassigned_devices') }}
        enabled={areUnassignedDevicesLoaded}
        decoration="textOnly"
        styles={{ button: { marginRight: 5 } }}
        text={`${unassignedDevices?.length ?? 0} Unassigned Devices`}
      />

      <Button decoration="positive" icon="new" onPress={onClickAddCustomer} text="Add Customer" />
    </S.Container>
  )
}

export default DeviceLinks

const S = {
  Container: styled.div`
    display: flex;
  `
}
